module.exports = __webpack_public_path__ + "img/check-verified-03.aa2006ff.svg";